import { useState } from 'react';
import useAuth from '../../hooks/useAuth';

/**
 * Cambiar la contraseña propia (HU-013) — a propósito separado del módulo
 * de Usuarios: cualquier persona logueada en el panel, sin importar su rol
 * o permisos, puede cambiar SU PROPIA contraseña acá; editar/crear otros
 * usuarios (`GestionUsuarios.jsx`) nunca vuelve a tocar contraseñas de
 * nadie. Pide la contraseña actual — la valida el backend, no alcanza con
 * tener la sesión abierta.
 */
const ModalCambiarPassword = ({ onCerrar }) => {
  const { cambiarMiPassword } = useAuth();
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordConfirmar, setPasswordConfirmar] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [guardando, setGuardando] = useState(false);

  const guardar = async (evento) => {
    evento.preventDefault();
    setMensaje('');

    if (passwordNueva.length < 8) {
      setMensaje('La nueva contraseña debe tener al menos 8 caracteres.');
      return;
    }
    if (passwordNueva !== passwordConfirmar) {
      setMensaje('La confirmación no coincide con la nueva contraseña.');
      return;
    }

    setGuardando(true);
    const resultado = await cambiarMiPassword(passwordActual, passwordNueva);
    setGuardando(false);

    if (resultado.success) {
      onCerrar();
    } else {
      setMensaje(resultado.error);
    }
  };

  return (
    <div className="panel-gu-modal-fondo" onClick={onCerrar}>
      <form className="panel-gu-modal" onClick={(e) => e.stopPropagation()} onSubmit={guardar}>
        <h3>Cambiar mi contraseña</h3>

        <label className="panel-label">Contraseña actual</label>
        <input
          type="password" className="panel-input" required autoFocus
          value={passwordActual} onChange={(e) => setPasswordActual(e.target.value)}
        />

        <label className="panel-label">Nueva contraseña</label>
        <input
          type="password" className="panel-input" required minLength={8}
          value={passwordNueva} onChange={(e) => setPasswordNueva(e.target.value)}
        />

        <label className="panel-label">Confirmar nueva contraseña</label>
        <input
          type="password" className="panel-input" required minLength={8}
          value={passwordConfirmar} onChange={(e) => setPasswordConfirmar(e.target.value)}
        />

        {mensaje && <p className="panel-gu-mensaje">{mensaje}</p>}

        <div className="panel-gu-modal-botones">
          <button type="button" className="panel-boton-secundario" onClick={onCerrar}>Cancelar</button>
          <button type="submit" className="panel-boton-primario" disabled={guardando}>
            {guardando ? 'Guardando…' : 'Cambiar contraseña'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ModalCambiarPassword;
